import { useEffect, useState } from "react";
import AddPhoto from "../../../assets/add-photo.png";
import DeleteIcon from "@mui/icons-material/Delete";

const ProductHeader = ({ onImageChange }) => {
  const [mainImage, setMainImage] = useState(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Revoke previous object URL if it exists
      if (mainImage && mainImage.preview) {
        URL.revokeObjectURL(mainImage.preview);
      }

      const newImage = {
        file,
        preview: URL.createObjectURL(file),
      };
      setMainImage(newImage);

      // Pass the image file to parent component if callback provided
      if (onImageChange) {
        onImageChange(file);
      }
    }
  };

  const handleDeleteImage = () => {
    if (mainImage) {
      // Revoke the URL to prevent memory leaks
      if (mainImage.preview) {
        URL.revokeObjectURL(mainImage.preview);
      }
      setMainImage(null);

      // Notify parent component that image was removed
      if (onImageChange) {
        onImageChange(null);
      }
    }
  };

  // Clean up URL when component unmounts
  useEffect(() => {
    return () => {
      if (mainImage && mainImage.preview) {
        URL.revokeObjectURL(mainImage.preview);
      }
    };
  }, [mainImage]);

  return (
    <div className="special-header">
      <p className="title">اضافة منتج جديد</p>
      <div className="product-form-img">
        {mainImage ? (
          <div className="image-container">
            <div className="image-wrapper">
              <img src={mainImage.preview} alt="صورة المنتج الرئيسية" />
              <button
                className="delete-btn"
                onClick={handleDeleteImage}
                type="button"
                aria-label="حذف الصورة"
              >
                <DeleteIcon />
              </button>
            </div>
          </div>
        ) : (
          <label htmlFor="main-image-upload" className="img-control">
            <img src={AddPhoto} alt="" />
            <span>اضافة صورة المنتج الرئيسية</span>
          </label>
        )}

        <input
          type="file"
          id="main-image-upload"
          accept="image/*"
          onChange={handleImageChange}
          style={{ display: "none" }}
          required={true}
        />
      </div>
    </div>
  );
};

export default ProductHeader;
